import React, { Component } from 'react';
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import ValidationText from "../../utils/validation/ValidationText.js";
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';
import moment from 'moment';
import { FinancealYearStartDateEndDate } from '../../utils/FinancialYearStartDateEndDate.js';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class InwardOutwardPostRegister extends Component {
    constructor(props) {
        super(props);
        this.despatchServices = new DespatchServices
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.state = {
            filterDetails: {
                startDate: "",
                endDate: "",
                partyId: "",
                category: "both",
            },
            totalCount: 0,
            tableStatus: "",
            inwardOutwardPostlist: [],
            partyDropdownList: [],
            categoryList: [
                { category: "Inward", value: "inward" },
                { category: "Outward", value: "outward" },
                { category: "Both", value: "both" },

            ],
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        let dates = FinancealYearStartDateEndDate()
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = dates.startDate
        filterDetails.endDate = dates.endDate
        this.setState({ filterDetails: filterDetails })
        this.getAllPartyDropdown()
    }
    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                    transporterName: item.transporterName
                }));
                this.setState({ partyDropdownList: dropdownItems }

                );
            } else {

                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };
    getAllInwardOutwardRegister = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ tableStatus: "Loading..." }, () => {
                let request = this.state.filterDetails
                this.despatchServices.getAllInwardOutwardRegister(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.setState({ inwardOutwardPostlist: response.responseData, totalCount: response.responseData.length })
                        if (response.responseData.length === 0) {
                            this.setState({ tableStatus: "No Record Found" })
                        } else {
                            this.setState({ tableStatus: "" })
                        }
                    } else {
                        this.setState({ tableStatus: "" })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails
        Fdetails.startDate = ""
        Fdetails.endDate = ""
        Fdetails.partyId = ""
        Fdetails.search = "both"
        this.setState({
            filterDetails: Fdetails, totalCount: 0, noItemFound: "", inwardOutwardPostlist: []
        });
    }

    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details });
    };
    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.filterDetails;
        details[drpIdentity] = selected.value;
        this.setState({ filterDetails: details });
    };
    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details },
        );

    };


    render() {
        return (
            <div className='inwardOutwardPostRegister-page'>
                <div className="item-search flex gap-2.5 !mb-3">
                    <div className="input-grp w-full" >
                        <label>Start Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                            type="date"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            value={this.state.filterDetails.startDate}
                            onChange={(event) =>
                                this.handleChange(event, "startDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.startDate}
                        /> */}
                    </div>
                    <div className="input-grp w-full">
                        <label>End Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                            type="date"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            value={this.state.filterDetails.endDate}
                            onChange={(event) =>
                                this.handleChange(event, "endDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.endDate}
                        /> */}
                    </div>
                    <div className="input-grp min-w-[40%]">
                        <label>Party Name</label>
                        <MultiSelectDropdown
                            drpIdentity="partyId"
                            options={this.state.partyDropdownList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                this.setFilterParameters(selected, "partyId")
                            }
                            allowSelectAll={false}
                            value={this.state.partyDropdownList.filter(
                                (party) =>
                                    party.value === this.state.filterDetails.partyId
                            )}
                        />

                    </div>
                    <div className="search-grp w-full">
                        <label>Category</label>
                        <select
                            name="category"
                            className="w-full"
                            value={this.state.filterDetails.category && this.state.filterDetails.category !== 'Select' && this.state.categoryList.find(
                                (party) => party.value === this.state.filterDetails.category
                            ).value}
                            onChange={(event) =>
                                this.handleDropDownChange(
                                    event,
                                    "category",
                                    "filterDetails"
                                )
                            }>
                            {this.state.categoryList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.category}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>
                <div className="btn-grp mb-3">
                    <button className="add-btn mt-auto" onClick={() => this.getAllInwardOutwardRegister()} >
                        Search
                    </button>
                    <button className="cancel-btn mt-auto" onClick={() => this.resetForm()} >Cancel</button>

                </div>
                <div className="table-upper mt-2.5">
                    <p className="mb-[3px] text-[15px] font-medium text-[#474747]" >
                        Total Count :- {this.state.totalCount ? this.state.totalCount : 0}
                    </p>
                </div>
                <div class="item-listing">
                    <div class="itemList-table">
                        <div class="table-container" style={{ height: "calc(100vh - 205px)" }} >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[15%]'>Category</td>
                                        <td className='w-[10%]'>Date</td>
                                        <td className='w-[20%]'>Party Name</td>
                                        <td className='w-[15%]'>P.O.D. No</td>
                                        <td className='w-[40%]'>Narration</td>
                                    </tr>
                                </thead>


                                <tbody>
                                    {this.state.inwardOutwardPostlist && this.state.inwardOutwardPostlist.length > 0 ? (
                                        this.state.inwardOutwardPostlist.map((details, key) => (
                                            <tr
                                                key={key}
                                            >
                                                <td>{details.category}</td>
                                                <td>{moment(details.date).format('DD MMM YYYY')}</td>
                                                <td>{details.partyId.partyName}</td>
                                                <td>{details.podNo}</td>
                                                <td>{details.narration}</td>
                                            </tr>
                                        ))
                                    ) : this.state.inwardOutwardPostlist &&
                                        this.state.inwardOutwardPostlist.length === 0
                                        && this.state.tableStatus !== "" ? (
                                        <tr>
                                            <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                {this.state.tableStatus}
                                            </td>
                                        </tr>
                                    ) : this.state.inwardOutwardPostlist &&
                                        this.state.inwardOutwardPostlist.length === 0
                                        && this.state.tableStatus === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default InwardOutwardPostRegister;